<template>
  <div
    v-if="attachments.length"
    v-show="showAttachmentGroup"
    data-cy="attachment-group"
    class="attachment-group"
  >
    <Attachment
      v-for="(attachment, index) in attachments"
      v-bind="attachmentDimensions[index]"
      :key="attachment.id"
      :style="attachmentStyles[index]"
      :src="attachment.src"
      :media-type="attachment.type"
      :alt="attachment.alt || alt"
      tight-fit
      @media-loaded="singleAttachmentLoaded"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import Attachment from '@/app/community/components/Attachment.vue';

const comp = defineComponent({
  name: 'AttachmentGroup',
  components: { Attachment },
  props: {
    attachments: { type: Array, default: () => [] },
    alt: { type: String, default: '' },
    flexibleDimensions: { type: Boolean, default: false },
  },
  emits: ['attachmentsLoaded'],
  data() {
    return {
      loadedAttachmentCount: 0,
    };
  },
  computed: {
    showAttachmentGroup() {
      return this.loadedAttachmentCount > 0;
    },
    attachmentStyles() {
      // Assign attachments to different areas of the grid depending on the number of attachments.
      switch (this.attachments.length) {
        case 1:
          return [{ gridArea: '1 / 1 / 3 / 3' }];
        case 2:
          return [{ gridArea: '1 / 1 / 3 / 2' }, { gridArea: '1 / 2 / 3 / 3' }];
        case 3:
          return [
            { gridArea: '1 / 1 / 3 / 2' },
            { gridArea: '1 / 2 / 2 / 3' },
            { gridArea: '2 / 2 / 3 / 3' },
          ];
        case 4:
          return [
            { gridArea: '1 / 1 / 2 / 2' },
            { gridArea: '1 / 2 / 2 / 3' },
            { gridArea: '2 / 1 / 3 / 2' },
            { gridArea: '2 / 2 / 3 / 3' },
          ];

        default:
          return [];
      }
    },
    attachmentDimensions() {
      if (this.flexibleDimensions) {
        return [];
      }
      switch (this.attachments.length) {
        case 1:
          return [{ displayWidth: '242px', displayHeight: '150px' }];
        case 2:
          return [
            { displayWidth: '120px', displayHeight: '150px' },
            { displayWidth: '120px', displayHeight: '150px' },
          ];
        case 3:
          return [
            { displayWidth: '120px', displayHeight: '150px' },
            { displayWidth: '120px', displayHeight: '74px' },
            { displayWidth: '120px', displayHeight: '74px' },
          ];
        case 4:
          return [
            { displayWidth: '120px', displayHeight: '74px' },
            { displayWidth: '120px', displayHeight: '74px' },
            { displayWidth: '120px', displayHeight: '74px' },
            { displayWidth: '120px', displayHeight: '74px' },
          ];

        default:
          return [];
      }
    },
  },
  methods: {
    singleAttachmentLoaded() {
      this.loadedAttachmentCount += 1;
      if (this.loadedAttachmentCount >= this.attachments.length) {
        this.$emit('attachmentsLoaded');
      }
    },
  },
});
export default comp;
</script>

<style scoped lang="postcss">
.attachment-group {
  display: grid;
  grid-template-rows: fit-content(50%) fit-content(50%);
  grid-template-columns: fit-content(50%) fit-content(50%);
  gap: var(--space-2);
}
</style>
